import { twMerge } from 'tailwind-merge';
import { BLOBS } from './constants';
import { classes, styles } from './utils';

export default function BackgroundBlobs() {
  return (
    <div aria-hidden className={classes.background}>
      {BLOBS.map(([blob, animation]) => (
        <div
          key={blob}
          style={styles.blob(animation)}
          className={twMerge(classes.blob, classes[blob])}
        />
      ))}
    </div>
  );
}
